/** @badge Native — TG UI Cell
 *  @when   строка списка/меню: кликабельная (onClick → button) или информационная (div)
 *  @not    самостоятельный блок с произвольным контентом — это Card/Section, не строка меню
 *  @breaks фон через style бьёт :hover/:active из Cell.module.css — ряд не откликается на тап
 */
"use client";

import { forwardRef, ReactNode } from "react";
import {
  Cell as TGCell,
  type CellProps as TGCellProps,
} from "@telegram-apps/telegram-ui";
import { haptic } from "@kit/hooks/useHaptic";
import s from "./Cell.module.css";

type HapticType = "light" | "medium" | "heavy" | "selection";

interface CellProps extends Omit<TGCellProps, "children" | "onClick" | "title"> {
  title: ReactNode;
  onClick?: () => void;
  hapticType?: HapticType;
}

export const Cell = forwardRef<HTMLElement, CellProps>(
  ({ title, onClick, hapticType = "selection", Component, className, style, ...props }, ref) => {
    const comp = Component ?? (onClick ? "button" : "div");
    // UA-хром и ховер живут в Cell.module.css: инлайн-стиль бил классовое
    // правило ховера у натива, и кликабельные строки переставали отзываться.
    const cls = [comp === "button" ? s.btn : s.inert, className].filter(Boolean).join(" ");
    return (
      <TGCell
        {...props}
        ref={ref as any}
        Component={comp}
        className={cls || undefined}
        style={style}
        onClick={() => { if (onClick) { haptic(hapticType); onClick(); } }}
      >
        {title}
      </TGCell>
    );
  }
);

Cell.displayName = "Cell";
